<template>
  <div class="modal fade" id="modify_strain" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="modal-block-vcenter" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="block block-themed block-transparent mb-0">
          <div class="block-header bg-primary">
            <h3 class="block-title"><i class="fa fa-cannabis"></i> Add Strain</h3>
            <div class="block-options">
              <button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close" @click.prevent="clearData()">
              <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <transition name="slide-fade">
            <div class="text-center alert-message-top" v-if="errorMsg">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="alert-message alert-danger alert-error-message">{{errorMsg}}</div>
              </div>
            </div>
          </transition>
          <div class="block-content">
            <div class="form-group required">
              <label class="control-label">Strain Name</label>
              <input type="text" v-model="name" name="strain_name" v-validate="'required'" data-vv-as="Strain Name" class="form-control form-control-alt" placeholder="Enter Strain Name">
              <p v-if="errors.has('strain_name')" class="errorMsg">{{ errors.first('strain_name') }}</p>
            </div>
            <div class="form-group">
              <label>Testing status</label>
              <input type="text" v-model="testingStatus" class="form-control form-control-alt" placeholder="Enter Testing status">
            </div>
            <div id="genetics" class="form-group">
              <label>Genetics</label>
              <input id="rangeSliderIndica" data-skin="round" class="js-rangeslider" type="text" data-min="0" data-max="100" data-from="0" />
            </div>
          </div>
          <div class="block-content block-content-full text-right border-top button-loader">
            <button type="button" class="btn btn-sm btn-light" data-dismiss="modal" @click.prevent="clearData()">Close</button>
            <button type="button" class="btn btn-sm btn-primary" @click="modifyStrain" :bind:disabled="showModalLoader">
              <div><i class="fa fa-save mr-1"></i><span>Save</span></div>
              <span class="modal-loader" v-if="showModalLoader">
                <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { VueSpinners } from '@saeris/vue-spinners';
import { HashLoader } from '@saeris/vue-spinners';
import { helper } from '@/helper.js';
import 'ion-rangeslider/css/ion.rangeSlider.min.css';
require('ion-rangeslider');

Vue.use(VeeValidate, VueSpinners);

export default {
  name: 'ModifyStrain',
  data() {
    return {
      id: 0,
      name: '',
      testingStatus: 'none',
      thcLevel: '',
      cbdLevel: '',
      indicaPercentage: '',
      sativaPercentage: '',
      showModalLoader: false,
      errorMsg: ''
    };
  },
  mounted() {
    let vm = this;
    jQuery('#rangeSliderIndica').ionRangeSlider({
      onChange: function(data) {
        vm.setRangeSliderColor(data);
      },
      onUpdate: function(data) {
        vm.setRangeSliderColor(data);
      }
    });
  },
  components: {
    HashLoader
  },
  methods: {
    clearData() {
      this.id = 0;
      this.name = '';
      this.thcLevel = '';
      this.cbdLevel = '';
      this.indicaPercentage = '';
      this.sativaPercentage = '';
      this.errorMsg = '';
      this.$validator.reset();
      this.resetSlider();
    },
    setRangeSliderColor(data) {
      jQuery('#genetics span.irs-single').removeClass('irs-hybrid irs-sativa irs-indica');
      jQuery('#genetics span.irs-handle').removeClass('irs-hybrid irs-sativa irs-indica');
      jQuery('#genetics span.irs-handle').removeClass('irs-border-hybrid irs-border-sativa irs-border-indica');
      let indica = data.from_percent, sativa = 100 - parseInt(data.from_percent);
      this.indicaPercentage = indica;
      this.sativaPercentage = sativa;
      jQuery('#genetics span.irs-min').text('Indica: ' + indica + '%');
      jQuery('#genetics span.irs-max').text('Sativa: ' + sativa + '%');
      jQuery('#genetics span.irs-min').attr('style', 'visibility: visible;');
      jQuery('#genetics span.irs-max').attr('style', 'visibility: visible;');
      if (indica === 50) {
        jQuery('#genetics span.irs-single').attr('style', 'display: block;');
        jQuery('#genetics span.irs-single').text('Hybrid');
        jQuery('#genetics span.irs-single').addClass('irs-hybrid');
        jQuery('#genetics span.irs-handle').addClass('irs-border-hybrid irs-hybrid');
        jQuery('#genetics span.irs-single').attr('style', 'left: 45%;');
      } else {
        jQuery('#genetics span.irs-single').attr('style', 'display: none;');
        if (indica > sativa) {
          jQuery('#genetics span.irs-single').addClass('irs-indica');
          jQuery('#genetics span.irs-handle').addClass('irs-border-indica irs-indica');
        } else {
          jQuery('#genetics span.irs-single').addClass('irs-sativa');
          jQuery('#genetics span.irs-handle').addClass('irs-border-sativa irs-sativa');
        }
      }
    },
    updateSlider(indicaPercentage) {
      let indicaSlider = jQuery('#rangeSliderIndica').data('ionRangeSlider');
      indicaSlider.update({from: indicaPercentage});
    },
    resetSlider() {
      this.updateSlider(0);
    },
    modifyStrain() {
      let vm = this;
      this.$validator.validate().then(valid => {
        if (valid) {
          vm.showModalLoader = true;
          vm.errorMsg = '';
          let action = this.id ? 'update' : 'create';
          helper.sendPostRequest('/strains/' + action, {
            'Name': vm.name,
            'Id': vm.id,
            'TestingStatus': vm.testingStatus,
            'ThcLevel': vm.thcLevel,
            'CbdLevel': vm.cbdLevel,
            'IndicaPercentage': vm.indicaPercentage,
            'SativaPercentage': vm.sativaPercentage
          }).then((data) => {
            vm.showModalLoader = false;
            if (data.status === 'success') {
              vm.$emit('loadStrains', true);
              jQuery('#modify_strain').modal('hide');
              vm.$emit('showSuccessMsg', data.message);
              vm.clearData();
            } else {
              vm.errorMsg = data.message;
            }
          });
        }
      });
    },
    loadStrain(strain) {
      this.id = strain.Id;
      this.name = strain.Name;
      this.testingStatus = strain.TestingStatus;
      this.thcLevel = strain.ThcLevel;
      this.cbdLevel = strain.CbdLevel;
      this.indicaPercentage = strain.IndicaPercentage;
      this.sativaPercentage = strain.SativaPercentage;
      this.updateSlider(strain.IndicaPercentage);
      this.setRangeSliderColor({from_percent: parseInt(strain.IndicaPercentage)});
    }
  }
};
</script>
<style>
#genetics span.irs-min {
  background: #6e335e !important;
  color: white !important;
}
#genetics span.irs-max {
  background: #d44727 !important;
  color: white !important;
}
#genetics span.irs-line {
  background: #d44727 !important;
}
#genetics span.irs-bar {
  background: #6e335e !important;
}
#genetics span.irs-hybrid {
  background: #77bc1f !important;
  color: white !important;
}
#genetics span.irs-hybrid::before {
  border-top-color: #77bc1f !important;
}
#genetics span.irs-indica {
  background: #6e335e !important;
  color: white !important;
}
#genetics span.irs-indica::before {
  border-top-color: #6e335e !important;
}
#genetics span.irs-sativa {
  background: #d44727 !important;
  color: white !important;
}
#genetics span.irs-sativa::before {
  border-top-color: #d44727 !important;
}
#genetics span.irs-border-sativa {
  border-color: #d44727 !important;
}
#genetics span.irs-border-indica {
  border-color: #6e335e !important;
}
#genetics span.irs-border-hybrid {
  border-color: #77bc1f !important;
}
</style>


// WEBPACK FOOTER //
// source/components/modals/ModifyStrain.vue